import { useState } from "react";
import { Modal, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import "./ModalAddTraining.sass";
import { useEffect } from "react";
import { defaultLevelsTranslate, myKnowledgeTranslate } from "../../../../i18n/translatedMessages";

const ModalAddTraining = ({ show, handleClose, handleAdd }) => {
  const emptyData = {
    courseName: "",
    typeOfSkill: "",
    radioLevel: "",
  };
  const [dataModal, setDataModal] = useState(emptyData);

  const handleChange = (event) => {
    const newDataModal = { ...dataModal };
    newDataModal[event.target.name] = event.target.value;
    setDataModal(newDataModal);
  };

  useEffect(() => {
    const emptyData = {
      courseName: "",
      typeOfSkill: "",
      radioLevel: "",
    };
    setDataModal(emptyData);
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-training modal-training-main"
    >
      <Modal.Header closeButton>
        <Modal.Title>{myKnowledgeTranslate.assignKnowledge}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <div className="mb-3">
            <FormattedMessage id={"className"}>
              {(msg) => (
                <input
                  type="text"
                  className="form-control"
                  placeholder={"Conocimiento"}
                  name="courseName"
                  onChange={(e) => handleChange(e)}
                />
              )}
            </FormattedMessage>

            <div className="row knowledge-type">
              <form>
                <div>{myKnowledgeTranslate.typeKnowledge}</div>
                <div className="col-3 ms-4 form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    value="language"
                    name="typeOfSkill"
                    onChange={(e) => handleChange(e)}
                  />
                  <label>{myKnowledgeTranslate.languageTrainingTitle}</label>
                </div>
                <div className="col ms-4 form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    value="skill"
                    name="typeOfSkill"
                    onChange={(e) => handleChange(e)}
                  />
                  <label>{myKnowledgeTranslate.otherTrainingTitle}</label>
                </div>
              </form>
            </div>

            <div className="row mt-4 knowledge-level">
              <div>{myKnowledgeTranslate.levelKnowledgeTitle}</div>
              <div className="col ms-4 form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  value="1"
                  name="radioLevel"
                  onChange={(e) => handleChange(e)}
                />
                <label>{defaultLevelsTranslate.basicLevel}</label>
              </div>
              <div className="col form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  value="2"
                  name="radioLevel"
                  onChange={(e) => handleChange(e)}
                />
                <label>{defaultLevelsTranslate.intermediaryLevel}</label>
              </div>
              <div className="col form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  value="3"
                  name="radioLevel"
                  onChange={(e) => handleChange(e)}
                />
                <label>{defaultLevelsTranslate.advancedLevel}</label>
              </div>
              <div className="col form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  value="4"
                  name="radioLevel"
                  onChange={(e) => handleChange(e)}
                />
                <label>{defaultLevelsTranslate.fluentLevel}</label>
              </div>
            </div>
          </div>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <FormattedMessage id={"createButton"}>
          {(msg) => (
            <button
              className="btn btn-green-add-training rounded-pill text-light px-4"
              onClick={async () => {
                await handleAdd(dataModal);
              }}
            >
              {"Agregar"}
            </button>
          )}
        </FormattedMessage>
      </Modal.Footer>
    </Modal>
  );
};
export default ModalAddTraining;
